import React from 'react';
import ViewContainer from '../containers/ViewContainer';
import NavigationService from '../service/NavigationService';
import {
  ON_NAVIGATION_REQUEST,
  EMPTY_PAYLOAD,
  ON_NAVIGATION_LOAD_SUCCESS,
  REGISTER_NAVIGATION_VIEWS,
  BEGIN_NAVIGATION_BINDING,
  BEGIN_NAVIGATION_LOAD,
} from '../actions/navigation';

const reducer = (state = {}, event = {}) => {
  switch (event.type) {
    case BEGIN_NAVIGATION_LOAD:
      return initializeNavigationItems(state, event);
    case ON_NAVIGATION_REQUEST:
      return onNavigationRequest(state, event);
    case EMPTY_PAYLOAD:
      return emptyPayload(state, event);
    case ON_NAVIGATION_LOAD_SUCCESS:
      return onNavigationLoadSuccess(state, event);
    case REGISTER_NAVIGATION_VIEWS:
      return onNavigationRegister(state, event);
    case BEGIN_NAVIGATION_BINDING:
      return onNavigationBinding(state);
    default:
      return state;
  }
};

const onNavigationRequest = (currentState, event) => {
  const { navItems = [], } = currentState;
  const { key, state, } = event.data;
  let tempNavItem;
  navItems.forEach((navItem) => {
    const { items = [], } = navItem;
    items.forEach((subItem) => {
      if (subItem.key === key) {
        tempNavItem = { ...subItem, };
        tempNavItem.requestedState = state;
      }
    });
  });

  return {
    ...currentState,
    payload: tempNavItem,
  };
};
const emptyPayload = state => ({
  ...state,
  payload: undefined,
});

const onNavigationRegister = (state, event) => {
  const { registeredViews = [], } = event;
  return {
    ...state,
    registeredViews,
  };
};

const onNavigationLoadSuccess = (state, event) => {
  const { raw = {}, } = event;
  return {
    ...state,
    raw,
  };
};

const onNavigationBinding = (state = {}) => {
  const { raw = [], registeredViews = [], } = state;
  const activeNavigationItems = [];
  const navItems = [];

  raw.forEach((navItem) => {
    navItem.items.forEach((tab) => {
      const { key, } = tab;
      if (key === undefined) {
        throw new Error('key is a required field for tabs');
      } else {
        const view = registeredViews[key];
        const { isActive, } = tab;
        if (view !== undefined && isActive) {
          const containedView = ViewContainer(view);
          const newTab = { ...tab, };
          newTab.getView = props => React.cloneElement(containedView, props);

          const existingNavItem = navItems.find(item => item.name === navItem.name);

          activeNavigationItems.push(newTab);

          if (existingNavItem) {
            existingNavItem.items.push(newTab);
          } else {
            const copyOfNavItem = { ...navItem, };
            copyOfNavItem.items = [ newTab, ];
            navItems.push(copyOfNavItem);
          }
        }
      }
    });
  });

  return {
    activeNavItems: activeNavigationItems,
    ...state,
    navItems,
  };
};

const initializeNavigationItems = (state, event) => {
  event.loadNavigationItems(NavigationService.getNavigationItems);

  return {
    ...state,
  };
};

export default reducer;
